function checkRequired() {
    var e = !0;
    return (
        $(".required").each(function () {
            $(this).val() == null || $(this).val().trim() == ""
                ? ((e = !1), $(this).parent().addClass("w-error"))
                : $(this).parent().removeClass("w-error");
        }),
        e
    );
}
function checkRequiredFields(containerId) {
    var r = !0;
    return (
        $("#" + containerId + " .required").each(function () {
            $(this).val() == null || $(this).val().trim() == ""
                ? ((r = !1), $(this).parent().addClass("w-error"))
                : $(this).parent().removeClass("w-error");
        }),
        r
    );
}
function IsEmail() {
    var e = /^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})+$/,
        r = $(".email").val();
    return r != ""
        ? e.test(r.trim())
            ? ($(".email").parent().removeClass("w-error"), !0)
            : ($(".email").parent().addClass("w-error"), !1)
        : !0;
}
function IsEmailFields(e) {
    var r = /^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})+$/,
        a = $("#" + e + " .email").val();
    return a != ""
        ? r.test(a.trim())
            ? ($(".email").parent().removeClass("w-error"), !0)
            : ($(".email").parent().addClass("w-error"), !1)
        : !0;
}
function IsPhoneNumber(e) {
    var r = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/,
        a = e == null || e == null ? $(".phoneNumber").val() : $("#" + e + " .phoneNumber").val();
    return a != ""
        ? r.test(a)
            ? ($(".phoneNumber").parent().removeClass("w-error"), !0)
            : ($(".phoneNumber").parent().addClass("w-error"), !1)
        : !0;
}

